module.exports = __webpack_public_path__ + "img/cloud2.7325f104.png";